var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTplink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#4accd5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24.2935 27.5193c-.0068 1.467-.0011 2.6967.0126 2.7326.0207.054.2852.0612 1.5385.0416 1.2559-.0195 1.6087-.0406 2.0731-.1238 1.9878-.3562 3.6606-1.1957 5.0782-2.5487 2.441-2.3297 3.4736-5.692 2.8021-9.1239-.5815-2.972-2.3721-5.3035-5.0539-6.5803-1.3278-.6322-2.6838-.9218-4.2921-.9167-1.6412.0052-2.9638.3118-4.3996 1.02-2.8904 1.4257-4.9035 4.2278-5.3004 7.3782-.0473.3753-.0854 3.2222-.0437 3.2638.014.014 4.9028.0367 5.3393.0248.0704-.0019.0809-.1389.1015-1.3238.0176-1.0107.0415-1.3947.1016-1.6314.413-1.6247 1.6426-2.8135 3.2883-3.1789.4574-.1015 1.4214-.0995 1.8802.0039 1.8173.4098 2.9657 1.8004 3.0934 3.7456.1239 1.8882-.9835 3.6698-2.6377 4.2437-.6544.2271-.8064.2461-2.2098.2765l-1.3592.0295zm-7.6484 8.6868c.2011.3866.5474.6693.9377.7653.0787.0193 1.1732.0319 2.4322.0279l2.2892-.0073v-6.1682-6.1681h-6.1521-6.1521v2.4291c0 2.2334.0068 2.4416.0844 2.5833.1336.2444.3635.4818.6017.6217l.22.1292 2.7899.0238 2.7899.0238.0239 2.7626.0238 2.7626z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTplink);
export default __webpack_public_path__ + "static/media/tplink.8937a4939af8b7da37a504c49c46d45c.svg";
export { ForwardRef as ReactComponent };